
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';

import CloseIcon from 'img/close-icon.svg';

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  container: {
    padding: "30px"
  },
  closeBtn: {
    width: "20px",
    cursor: "pointer",
    position: "absolute",
    top: "15px",
    right: "15px"
  }
});

export default function DefinitionDialog({ onClose, open }) {
  const classes = useStyles()
  const handleClose = () => onClose()

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} disableScrollLock={true}>
      <div onClick={handleClose}><img alt="" className={classes.closeBtn} src={CloseIcon} /></div>
      <div className={classes.container}>
        <Typography variant="h4" align="center" style={{ fontFamily: "Arvo" }}>Policy Definitions</Typography>
        <br />
        <Typography variant="h6" style={{ fontFamily: "Arvo" }}>Remote-First</Typography>
        <Typography variant="body1" style={{ fontFamily: "Lato" }}>{`Remote-first companies design their processes (only virtual meetings, online social gatherings, etc.) around remote employees and often prefer to hire them.`}</Typography>
        <br />
        <Typography variant="h6" style={{ fontFamily: "Arvo" }}>Remote-Friendly</Typography>
        <Typography variant="body1" style={{ fontFamily: "Lato" }}>{`Remote-friendly companies hire for many remote positions while also allowing/requiring people to work together in-person.`}</Typography>
        <br />
        <Typography variant="h6" style={{ fontFamily: "Arvo" }}>Fully Distributed</Typography>
        <Typography variant="body1" style={{ fontFamily: "Lato" }}>{`Fully distributed companies don't have physical office spaces and thus only hire employees that work from home (or elsewhere).`}</Typography>
      </div>
    </Dialog>
  );
}

DefinitionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};
